module.exports = __webpack_public_path__ + "img/02-6分析.7763efbf.svg";